module.exports = __webpack_public_path__ + "img/logo-black-cn.6a27df4f.svg";